/*
 * used to convert string into camel Case
 */
export const camelCase = (str) => {
    // Using replace method with regEx
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index == 0 ? word.toUpperCase() : word.toLowerCase()
        })
        .replace(/\s+/g, '')
}
/*
 * rounding off the amount
 */
export const priceRoudOff = (amount) => {
    return amount ? Math.round(amount * Math.pow(10, 2)) : 0
}
/*
 * return shipping options for express checkout
 */
export const getShippingOptions = async (shippingMethods) => {
    const shippingOptions = []
    const availableShippingMethods = shippingMethods?.applicableShippingMethods
    availableShippingMethods?.forEach((shippingMethod) => {
        shippingOptions.push({
            id: shippingMethod.id,
            displayName: shippingMethod.name,
            amount: priceRoudOff(shippingMethod.price)
        })
    })
    return shippingOptions
}
/**
 * return order summary items for express checkout
 */
export const getOrderSummaryItems = async (basket) => {
    const orderSummaryItems = [
        {
            name: 'Sub Total',
            amount: priceRoudOff(basket?.productSubTotal)
        },
        {
            name: 'Tax',
            amount: priceRoudOff(basket?.taxTotal)
        },
        {
            name: 'Shipping cost',
            amount: priceRoudOff(basket?.shippingTotal)
        }
    ]

    return orderSummaryItems
}
/**
 * formate the address passed
 */
export const formatAddress = async (address) => {
    const addressObject = {
        address1: address?.line1 || '',
        address2: address?.lien2 || '',
        city: address?.city,
        countryCode: address?.country,
        stateCode: address?.state,
        postalCode: address?.postal_code
    }
    return addressObject
}
/**
 * formate the payer name
 */
export const formatName = async (fullname) => {
    const payerName = {}
    if (fullname) {
        const payerNameSplit = fullname.split(' ')
        if (payerNameSplit?.length > 1) {
            payerName.firstName = payerNameSplit[0]
            payerName.lastName = payerNameSplit[1]
        } else {
            payerName.firstName = fullname
            payerName.lastName = fullname
        }
    }
    return payerName
}
/*
 * This is used to create payment instruments
 * @param {object} params
 */
export const createPaymentInstruments = async (
    basket,
    cardDetails,
    addPaymentInstrumentToBasket,
    paymentMethodId
) => {
    const maskedDigits = '************'
    let amount = basket?.orderTotal ?? 0
    const GCInstrument = basket?.paymentInstruments?.find(
        (pi) => pi?.paymentMethodId === 'GIFT_CERTIFICATE'
    )
    if (GCInstrument?.amount && GCInstrument.amount < amount) {
        amount -= GCInstrument.amount
    }
    const paymentInstrument = {
        paymentMethodId: paymentMethodId,
        amount: amount,
        paymentCard: {
            cardType: cardDetails?.brand && camelCase(cardDetails?.brand),
            maskedNumber: cardDetails ? maskedDigits + cardDetails?.last4 : undefined,
            expirationMonth: cardDetails?.exp_month,
            expirationYear: cardDetails?.exp_year
        }
    }

    return addPaymentInstrumentToBasket({
        parameters: {basketId: basket?.basketId},
        body: paymentInstrument
    })
}
/*
 * This is used to update shipping address
 */
export const handleShippingAddressChange = async (
    basket,
    address,
    updateShippingAddressForShipment
) => {
    const updateShippingAddress = await updateShippingAddressForShipment({
        body: address,
        parameters: {
            basketId: basket.basketId,
            shipmentId: 'me'
        }
    })

    return updateShippingAddress
}

export const handleShipmentDetails = async (
    basket,
    address,
    shipmentId,
    shippingMethodId,
    UpdateShipmentForBasket
) => {
    const updateShippingDetails = await UpdateShipmentForBasket({
        body: {
            shipmentId: shipmentId,
            shippingMethod: {
                id: shippingMethodId
            },
            shippingAddress: address
        },
        parameters: {
            basketId: basket.basketId,
            shipmentId: 'me'
        }
    })

    return updateShippingDetails
}

/*
 * This is used to update sected shipping method on modal
 */
export const handleShippingRateChange = async (
    updateShippingMethod,
    authToken,
    site,
    shippingRate,
    basket
) => {
    const shippingMethodObject = await updateShippingMethod({
        parameters: {
            basketId: basket?.basketId,
            shipmentId: 'me'
        },
        body: {
            id: shippingRate?.id
        }
    })
    return shippingMethodObject
}
/*
 * This is used to update sected shipping method on modal
 */
export const handleBillingAddress = async (basket, address, updateBillingAddressForBasket) => {
    return updateBillingAddressForBasket({
        body: address,
        parameters: {basketId: basket.basketId}
    })
}
export const handleCutomer = async (basket, email, updateCustomerForBasket) => {
    return updateCustomerForBasket({
        parameters: {basketId: basket?.basketId},
        body: {
            email: email
        }
    })
}
/*
 * This will execute from googlePay or ApplePay model when user clicks pay button
 * @param {object} params
 * returns {object} authResult
 */
export const handlePayment = async (params) => {
    const event = params?.event
    const basket = params?.basket
    const updateShippingAddressForShipment = params?.updateShippingAddressForShipment
    const updateBillingAddressForBasket = params?.updateBillingAddressForBasket
    const updateCustomerForBasket = params?.updateCustomerForBasket
    let authResult = {
        status: false
    }
    try {
        const payerPhone = event?.billingDetails?.phone
        const payerName = event?.billingDetails?.name
        const payerEmail = event?.billingDetails?.email
        let firstName, lastName
        if (payerName) {
            const payerNameSplit = payerName.split(' ')
            if (payerNameSplit?.length > 1) {
                firstName = payerNameSplit[0]
                lastName = payerNameSplit[1]
            }
        }

        // update shipping address
        const shippingAddObj = await formatAddress(event?.shippingAddress?.address)
        shippingAddObj.firstName = firstName || payerName
        shippingAddObj.lastName = lastName || payerName
        await handleShippingAddressChange(basket, shippingAddObj, updateShippingAddressForShipment)

        // update billing addres and customer email
        const billingAddObj = await formatAddress(event?.billingDetails?.address)
        billingAddObj.firstName = firstName || payerName
        billingAddObj.lastName = lastName || payerName
        billingAddObj.phone = payerPhone
        await handleBillingAddress(basket, billingAddObj, updateBillingAddressForBasket)

        // update customer with express checkout email
        const result = await handleCutomer(basket, payerEmail, updateCustomerForBasket)

        authResult.status = true
        authResult.basket = result
    } catch (error) {
        console.log('stripe-utils : handlePayment - exception occured ', error.message)
        authResult.errorMessage = error.message
        return authResult
    }

    return authResult
}
/*
 * used to create an order
 * @param {string} usid - user Id
 * @param {basket} basket - current basket
 * @params {createOrder} createOrder - a crateOrderMutate
 */
export const stripeCreateOrder = async (usid, basket, createOrder) => {
    return await createOrder({
        // We send the SLAS usid via this header. This is required by ECOM to map
        // Einstein events sent via the API with the finishOrder event fired by ECOM
        // when an Order transitions from Created to New status.
        // Without this, various order conversion metrics will not appear on reports and dashboards
        headers: {_sfdc_customer_id: usid},
        body: {basketId: basket.basketId}
    })
}
